<template>
    <window :title="title">
        <Question
            :questions="questions"
            :tmp-selected="selected"
            :tmp-result="result"
            :test-mode="true"
        />
    </window>
</template>

<script>
import Question from "@/components/question";

export default {
    name: "test",
    components: {
        Question,
    },
    data() {
        return {
            title: "テスト編",
            selected: {
                q1: "",
                q2: "",
                q3: "",
            },
            result: {
                q1: "",
                q2: "",
                q3: "",
            },
        };
    },
    computed: {
        questions() {
            let res = require(`@/assets/${this.$route.params.contents}.json`);
            return res;
        },
    },
    mounted() {
        this.$store.commit("setLastTime", {
            contents:
                this.$route.params.contents.substring(0, 1).toUpperCase() +
                this.$route.params.contents.substring(1),
            page: "test",
        });
    },
};
</script>